import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { ArcaneMarquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Grimoires } from "@/components/Grimoires";
import { Tarot } from "@/components/Tarot";
import { Testimonials } from "@/components/Testimonials";
import { Pricing } from "@/components/Pricing";
import { EnquiryForm } from "@/components/EnquiryForm";
import { Footer } from "@/components/Footer";
import { WhatsAppSigil } from "@/components/WhatsAppSigil";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <ArcaneMarquee />
      <Services />
      <Grimoires />
      <Tarot />
      <Testimonials />
      <Pricing />
      <EnquiryForm />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <CurrencyProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/sanctum/login" element={<Login />} />
              <Route path="/sanctum" element={<Dashboard />} />
            </Routes>
          </BrowserRouter>
          <WhatsAppSigil />
          <Toaster theme="dark" position="bottom-right" richColors />
        </AuthProvider>
      </CurrencyProvider>
      <div className="grain-overlay" />
    </div>
  );
}

export default App;
